export default {
  SET_SHARE_TYPE: '[share] set share type',
  SET_USER_INFO: '[share] set user info',
  SET_COURSE: '[share] set course'
}
